export default "__VITE_ASSET__b374bdf6__"